import { Container, Typography } from "@material-ui/core";
import React from "react";
import { connect } from "react-redux";
import { deRegister } from "../actions";
import { SaspButton } from "../components";
import { deviceData } from "../common";

const DeregisterScreen = props => {
    if (props.feedback.mcid && props.feedback.key) {
        return (
            <Container className="deregister_container">
                <Typography className="deregister_text" varient="body1">
                    You have more than two devices registered. Please deregister your
                    other devices.
                </Typography>
                <Typography className="deregister_text" varient="body1">
                    <strong>Note</strong>: You will be logged out of the application on the
                    other devices.
                </Typography>
                <SaspButton
                    className="deregister_button"
                    color="secondaryBlue"
                    onClick={() => props.deRegister(props.feedback.mcid, props.feedback.key)}
                >
                    Deregister
                </SaspButton>
            </Container>
        );
    } else {
        return <div>deregister</div>;
    }
};

const mapStateToProps = state => {
    const feedback = state.auth.auth_feedback;
    return { feedback };
};

export default connect(mapStateToProps, { deRegister })(DeregisterScreen);
